module.exports = __webpack_public_path__ + "img/katarina_bathrooms_6.67759e91.jpg";